import { useIssueCreateSidePanelContext } from '../providers/IssueCreateSidePanelContextProvider';

import { useIsAIIssueCreationAllowed } from './useIsAIIssueCreationAllowed';
import { getIsCreateIssueWithAiEnabledByUser } from './localStorageHelpers';

export const useIsAIIssueCreationEnabled = () => {
	const [{ contentId }] = useIssueCreateSidePanelContext();
	const aiIssueCreationEnablement = useIsAIIssueCreationAllowed({ contentId });
	const isAiEnabled = aiIssueCreationEnablement?.isEnabled ?? false;
	const isCreateIssueWithAiEnabledByUser = getIsCreateIssueWithAiEnabledByUser();

	return isAiEnabled && isCreateIssueWithAiEnabledByUser;
};
